import { useState } from "react";

interface Props {
  html: string;
  minHeight?: number;
  className?: string;
}

/**
 * Renders email HTML inside an iframe via srcDoc so inline styles, background
 * colors, and table styling render exactly as in a real email client.
 */
export const EmailPreviewIframe = ({ html, minHeight = 600, className }: Props) => {
  const [height, setHeight] = useState<number>(minHeight);

  const fullHtml = `<!DOCTYPE html>
<html>
  <head>
    <meta charset="utf-8">
    <meta name="viewport" content="width=device-width">
    <style>
      html, body { margin: 0; padding: 0; background: #F3F4F6; }
      * { box-sizing: border-box; }
      body { padding: 24px 16px; }
    </style>
  </head>
  <body>${html || "<p><em>(empty)</em></p>"}</body>
</html>`;

  return (
    <iframe
      title="Email preview"
      srcDoc={fullHtml}
      className={className ?? "w-full rounded-md border border-border bg-white"}
      style={{ width: "100%", border: "none", display: "block", height }}
      onLoad={(e) => {
        const doc = (e.target as HTMLIFrameElement).contentDocument;
        if (doc) {
          setHeight(Math.max(doc.documentElement.scrollHeight, minHeight));
        }
      }}
    />
  );
};
